// Format price with currency (convert from kobo to naira)
const formatPrice = (price: string, currency?: string) => {
  // Convert kobo to naira (1 naira = 100 kobo)
  const priceInNaira = Number(String(price).replace(/,/g, ""));

  return new Intl.NumberFormat("en-NG", {
    style: "decimal",
    // style: "currency",
    // currency: currency,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(priceInNaira);
};

export default formatPrice;
